import { HotelInfoModel, HotelSearchRequest, RoomSearchInfo } from '@/__generated';
import SearchBox from '@/components/App/SearchBox/SearchBox';
import { SearchBoxBackgroundImage } from '@/config';
import { generateHotelSearchUrl } from '@/urls';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Collapse, Card, CardBody } from 'reactstrap';

type Props = {
  hotelInfo: HotelInfoModel;
  onSearchDetailHotel: (hotelName: string, hotelCode: string, checkinDate: any, checkoutDate: any, boardType: any, rooms: RoomSearchInfo[]) => void;
};
const MAX_WIDTH_DISPLAY_SEARCHBOX = 1000;

export default function HotelDetailSearchBox({ hotelInfo, onSearchDetailHotel }: Props) {
  const history = useHistory();
  const [isOpen, setIsOpen] = React.useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const onSearchHotel = (request: HotelSearchRequest) => {
    let url = generateHotelSearchUrl(request);
    history.push(url);
  };
  if (window.innerWidth < MAX_WIDTH_DISPLAY_SEARCHBOX) {
    return (
      <>
        <div className=" py-10 bg-dark-1 text-center text-white" onClick={toggle}>
          {isOpen ? (
            <>
              Hide search box
              <FontAwesomeIcon icon={faChevronUp} className="ml-15" />
            </>
          ) : (
            <>
              {' '}
              Show search box
              <FontAwesomeIcon icon={faChevronDown} className="ml-15" />
            </>
          )}
        </div>
        <Collapse isOpen={isOpen}>
          <section className="pt-10 pb-10 bg-light-2 masthead -type-1 z-5">
            <div className="masthead__bg">
              <img alt="logo" src={SearchBoxBackgroundImage} className="js-lazy" />
            </div>

            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="mainSearch bg-white px-10 py-10 lg:px-20 lg:pt-5 lg:pb-20 rounded-0">
                    <SearchBox onSearchHotel={onSearchHotel} hotelInfo={hotelInfo} onSearchDetailHotel={onSearchDetailHotel} height="h-50" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Collapse>
      </>
    );
  }
  return (
    <section className="pt-10 pb-10 bg-light-2 masthead -type-1 z-5">
      <div className="masthead__bg">
        <img alt="logo" src={SearchBoxBackgroundImage} className="js-lazy" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="mainSearch  bg-white px-10 py-10 xl:px-20 xl:pt-5 xl:pb-20 rounded-4">
              <SearchBox onSearchHotel={onSearchHotel} hotelInfo={hotelInfo} onSearchDetailHotel={onSearchDetailHotel} height="h-50" />
            </div>
          </div>
          {/* End col-12 */}
        </div>
      </div>
    </section>
  );
}
